<template>
	<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
		<FormItem label="关联">
			<Select v-model="formItemdate.relevance" style="width:200px">
				<Option v-for="item in relevanceList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
			<Select v-show="formItemdate.relevance !== 'huifang'" v-model="formItemdate.relevanceDetails" style="width:200px; margin-left: 10px;">
				<Option v-for="item in relevanceDetailsList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
		</FormItem>
		<FormItem label="任务主题" prop="name">
			<Input v-model="formItemdate.theme" placeholder="请输入任务主题"></Input>
		</FormItem>
		<FormItem label="任务描述" prop="mail">
			<editor-bar v-model="formItemdate.describe" :isClear="isClear"></editor-bar>
		</FormItem>
		<div class="xinjianbottom">
			<div>
				<FormItem label="截止时间" prop="date">
					<Row>
						<Col span="8">
						<DatePicker type="date" placeholder="请选择日期" :value="formItemdate.cutDate" @on-change="(e) => {formItemdate.cutDate}"></DatePicker>
						</Col>
						<Col span="1" style="text-align: center">-</Col>
						<Col span="8">
						<TimePicker type="time" placeholder="请选择时间" v-model="formItemdate.cutTime"></TimePicker>
						</Col>
					</Row>
				</FormItem>
				<FormItem label="状态">
					<CheckboxGroup v-model="formItemdate.social">
						<Checkbox label="紧急">

						</Checkbox>
						<Checkbox label="已完成">

						</Checkbox>
					</CheckboxGroup>
				</FormItem>
				<FormItem label="任务属性" prop='tichuzhe'>
					<RadioGroup v-model="formItemdate.animal">
						<Radio label="外勤"></Radio>
						<Radio label="内勤"></Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="日程排期" v-for='(item,i) in tianjiapaiqi' :key='i'>
					<Row>
						<Col span="8">
						<DatePicker type="date" placeholder="请选择日期" :value="formItemdate.scheduleDate[i]" @on-change="(e) => {formItemdate.scheduleDate[i] = e}"></DatePicker>
						</Col>
						<Col span="1" style="text-align: center">-</Col>
						<Col span="8">
						<TimePicker v-model="formItemdate.scheduleTime[i]" format="HH:mm" type="timerange" placement="bottom-end"
						 placeholder="请选择时间段"></TimePicker>
						</Col>
						<Col span="3" style="text-align: center;">
						<a href="javascript:void(0)">
							<div class="shanchupaiqi icon iconfont icon-jian" @click="shanchupaiqihanshu(i)"></div>
						</a>
						</Col>
					</Row>
				</FormItem>
				<div style="display: flex; justify-content: space-between;">
					<Button type='primary' @click='tianjiapaiqihanshu'>添加排期</Button>
					<Button style="position: relative;left: 300px;"  type='primary' @click='okSaveClick'>确认保存</Button>
				</div>
			</div>

			<div>
				<FormItem label="耗时">
					<Input v-model="formItemdate.manHour " placeholder="请输入人工工时"></Input>
				</FormItem>
				<FormItem label="提出者">
					<Input disabled v-model="formItemdate.comePeople " placeholder="请输入提出者"></Input>
				</FormItem>
				<FormItem label="执行者" prop='tichuzhe' v-for='(item,index) in tianjiazhipairen' :key='index'>
					<div style="display: flex; align-items: center;">
						<Select disabled v-model="formItemdate.zhixingzhe[index]" style="width: 200px;">
							<Option v-for="item in zhipairenList" :value="item.value">{{ item.label }}</Option>
						</Select>
						<a href="javascript:void(0)" v-show="false">
							<div @click="shanchuzhipairenhanshu(index)" class="shanchuzhipairen icon iconfont icon-jian"></div></span>
						</a>

					</div>
				</FormItem>
			</div>
		</div>
	</Form>
</template>

<script>
	import EditorBar from '../wangEnduit/WangEnduit.vue'
	export default {
		name: "shouyeEditTask",
		components: {
			EditorBar
		},
		data() {
			return {
				relevanceDetailsList: [],
				//关联第一个下拉框
				relevanceList: [{
						value: 'anjian',
						label: '案件任务'
					},
					{
						value: 'qita',
						label: '其他任务'
					},
					{
						value: 'huifang',
						label: '回访任务'
					},
					{
						value: 'miantan',
						label: '面谈任务'
					},
				],
				zhipairenList: [{
						value: 'beijing',
						label: '张三'
					},
					{
						value: 'shanghai',
						label: '李四'
					},
					{
						value: 'shenzhen',
						label: '周五'
					}
				],
				tianjiazhipairen: [''],
				tianjiapaiqi: [''],
				isClear: false,
				formItemdate: {
					// 关联1
					relevance: '',
					// 关联的详细
					relevanceDetails: '',
					// 输入的任务主题
					theme: '',
					// 输入的描述
					describe: "",
					// 截止日期
					cutDate: '',
					// 截止时间
					cutTime: '',
					// 状态
					social: [],
					// 任务属性
					animal: '',
					scheduleDate: [''],
					scheduleTime: [
						['', '']
					],
					// 工时
					manHour: '',
					// 提出者
					comePeople:'',
					zhixingzhe: ['']

				},
				formValidate: {
					name: '',
					mail: '',
					city: ''
				},
				ruleValidate: {
					name: [{
						required: true,
						message: '任务主题不能为空',
						trigger: 'blur'
					}],
					city: [{
						required: true,
						message: 'Please select the city',
						trigger: 'change'
					}, ],
					date: [{
						required: true,
						type: 'date',
						message: 'Please select the date',
						trigger: 'change'
					}],

				},
			}
		},
		methods: {
			// 确认保存按钮
			okSaveClick() {
				this.$emit('okSaveClick')
			},
			shanchupaiqihanshu(index) {
				if (this.tianjiapaiqi.length > 1) {
					this.tianjiapaiqi.splice(index, 1)
					this.formItemdate.scheduleDate.splice(index, 1)
					this.formItemdate.scheduleTime.splice(index, 1)
				}
			},
			tianjiapaiqihanshu() {
				this.tianjiapaiqi.push('')
				this.formItemdate.scheduleDate.push('')
				this.formItemdate.scheduleTime.push(['', ''])
			},
			shanchuzhipairenhanshu(index) {
				if (this.tianjiazhipairen.length > 1) {
					this.tianjiazhipairen.splice(index, 1)
					this.formItemdate.zhixingzhe.splice(index, 1)
				}
			},
			tianjiazhipairenhanshu() {
				this.tianjiazhipairen.push('')
				this.formItemdate.zhixingzhe.push('')
			},
		}
	}
</script>

<style scoped lang="less">
	.xinjianbottom {
		margin-top: 60px;
		display: flex;
		justify-content: left;
	}

	.shanchupaiqi {
		color: #277dd3;
	}

	.shanchuzhipairen {
		color: #277dd3;
	}
</style>
